module.exports = __webpack_public_path__ + "static/media/2_The inner voice_FR.248733fb.txt";